<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4">
        <approve-model-risk-form
          ref="riskModelForm"
          :project-id="project.id"
          :type="project.client.fiscal.fiscal_type"
          :schema.sync="schemaResponse" />
      </div>
      <div class="col-md-8">
        <template v-if="responseModel">
          <div class="vx-row">
            <model-risk-analytics
              class="float-right"
              :project-data="project"
              :score="parseFloat(responseModel.score)"
              :qualification="qualification"
              :project="getChartScoreByGroupName('Proyectos')"
              :personalProfile="getChartScoreByGroupName('Perfil: Personales')"
              :capacityPayment="getChartScoreByGroupName('Capacidad de pago')"
              :scoreAndBehaviour="getChartScoreByGroupName('Reputación y comportamiento')" />
          </div>

          <vs-table stripe :data="responseModel.results.groups">
            <template slot="thead" class="thead-dark">
              <vs-th>Regla</vs-th>
              <vs-th>Peso de la categoría</vs-th>
              <vs-th>Resultado</vs-th>
              <vs-th>Porcentaje</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr
                v-for="(group, index) in data"
                :key="index"
                v-bind:class="{'text-danger': group.result <= 50}"
                v-if="group.rules.length > 0">
                <vs-td><strong>{{group.name}}</strong></vs-td>
                <vs-td>{{group.weight|fixNumber}}%</vs-td>
                <vs-td>{{group.result|fixNumber}} %</vs-td>
                <vs-td>{{group.score|fixNumber}}</vs-td>

                <template slot="expand">
                  <div class="con-expand-users w-full">
                    <vs-table :data="group.rules">
                      <template slot="thead">
                        <vs-th>Indicadores</vs-th>
                        <vs-th>Peso indicador</vs-th>
                        <vs-th>Puntaje indicador</vs-th>
                        <vs-th>Calificación indicador</vs-th>
                        <vs-th>Respuesta</vs-th>
                        <vs-th>Limite inferior</vs-th>
                        <vs-th>Limite superior</vs-th>
                        <vs-th>Tipo de análisis</vs-th>
                      </template>
                      <template slot-scope="{data}">
                        <vs-tr
                          v-for="rule in data"
                          v-bind:class="{'text-danger': rule.score <= 50}"
                          :key="`trx-${rule.identity_name}`">
                          <vs-td><strong>{{rule.name}}</strong></vs-td>
                          <vs-td>{{rule.weight|fixIfIsFloat}}%</vs-td>
                          <vs-td>{{rule.result|fixIfIsFloat}}</vs-td>
                          <vs-td>{{rule.score|fixIfIsFloat}}%</vs-td>
                          <vs-td>{{rule.answer|fixIfIsFloat}}</vs-td>
                          <vs-td>{{rule.worst_value}}</vs-td>
                          <vs-td>{{rule.best_value}}</vs-td>
                          <vs-td>
                            {{rule.analysis_type.type}}
                            <template v-if="rule.analysis_type.type === 'Catalog'">
                              {{rule.analysis_type.argument}}
                            </template>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </template>
              </vs-tr>
            </template>

          </vs-table>
        </template>

        <vs-button
          :disabled="this.$refs.riskModelForm && this.$refs.riskModelForm.formError !== ''"
          class="mt-5" @click="runApproveModel()">
          Modelo de Aprobación
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import ModelRiskAnalytics from "@views/admin/RiskModel/Dashboard/RiskModel/ModelRiskAnalytics";
import ApproveModelRiskForm from "@views/admin/RiskModel/Dashboard/RiskModel/ApproveForm/ApproveModelRiskForm";
import RiskModelResult from "@views/admin/RiskModel/Dashboard/RiskModel/Components/RiskModelResult";
import {fixNumber} from "@/filters/NumberFilters";
import {mapState} from "vuex";
import * as RMScoreQualificationRatesJson from '@/dbjson/rkm_score_qualification_rates.json'

export default {
  name: "ApproveModelRiskV2",
  components: {RiskModelResult, ApproveModelRiskForm, ModelRiskAnalytics},
  data: () => ({
    schemaResponse: {},
    qualification: {},
    responseModel: null
  }),
  props: ["preApproveRiskModelScore", "showQualification"],
  computed: {
    ...mapState("projects", ["project"]),
  },
  filters: {
    fixNumber,
    fixIfIsFloat(val) {
      if(typeof val == 'number' && !isNaN(val)) {
        if (!Number.isInteger(val)) {
          return val.toFixed(2)
        }
      }
      return val;
    }
  },
  async mounted() {
    try {
      const { data } = await axios.post("/api/risk-model/approve", {
        projectId: this.project.id
      })

      this.responseModel = data.current;

      if (this.responseModel) {
        this.changeQualificationDate();
      }
      this.$emit("onLoaded", data)
    } catch (e) {

    }
  },
  methods: {
    changeQualificationDate() {
      let qualificationRates = new QualificationRates(new JsonFileScoreQualificationRateRepository());
      this.qualification = qualificationRates.getQualification(this.responseModel.score);
    },
    getChartScoreByGroupName(groupName) {
      let groupProject = this.responseModel.results.groups.filter((g) => g.name === groupName)
      if(groupProject.length > 0) {
        return parseFloat(parseFloat(groupProject[0].result).toFixed(2));
      }
      return 0;
    },
    async runApproveModel() {
      this.$vs.loading();
      try {
        const { data } = await axios.post(`/api/risk-model/approve/run`, {
          projectId: this.$route.params.id,
          type: this.project.client.fiscal.fiscal_type
        })

        this.responseModel = data;

        this.changeQualificationDate();
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}


class QualificationRates
{
  items = []

  /**
   * @param {JsonFileScoreQualificationRateRepository} qualificationRateRepository
   */
  constructor(qualificationRateRepository) {
    this.qualificationRateRepository = qualificationRateRepository;
    this.items = this.qualificationRateRepository.all()
  }

  /**
   * @param {Number} score
   * @return ScoreQualificationRateRange|null
   */
  getQualification(score) {
    let findItems = this.items.filter((item) => item.min <= score && item.max > score)
    if (findItems.length > 0) {
      return findItems[0];
    }
    return null;
  }
}

class JsonFileScoreQualificationRateRepository
{
  /**
   * @return ScoreQualificationRateRange[]
   */
  all() {
    let items = [];
    for(let range of RMScoreQualificationRatesJson.pf) {
      items.push(
        new ScoreQualificationRateRange(
          parseFloat(range.min),
          parseFloat(range.max),
          range.qualification,
          parseFloat(range.rate))
      )
    }
    return items;
  }
}

export class ScoreQualificationRateRange {
  constructor(min, max, qualification, rate) {
    this.min = min;
    this.max = max;
    this.qualification = qualification;
    this.rate = rate;
  }
}
</script>

<style scoped>

</style>
